const areAdvancedColorsChanged = (initialPalette, updatedPalette) => {
  const initial = initialPalette?.advancedColors || {};
  const updated = updatedPalette?.advancedColors || {};

  const initialKeys = Object.keys(initial);
  const updatedKeys = Object.keys(updated);

  if (initialKeys.length !== updatedKeys.length) {
    return true;
  }

  return initialKeys.some((key) => initial[key] !== updated[key]);
};

export default areAdvancedColorsChanged;
